import Field from "../Field";

export default class ReservedPressureDropForDPCPressure extends Field {
    get label() {
        return __('Reserved pressure drop for DPC')
    }
}